import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';
import { environment } from 'src/environments/environment';
import { buildHttpParams } from '@/common/utils/http-params.util';
import { toLocalIsoDate } from '@/common/utils/to-local-iso-date.util';
import { PaymentMethodsResponse, ReportListFilters, ReportListResponse } from '@/tms/reports/_models/reports.model';

@Injectable({ providedIn: 'root' })
export class ReportsApiService {
	private readonly http = inject(HttpClient);
	private readonly baseUrl = `${environment.erpSymfonyUrl}/api/v1/tms/gbox-responses`;

	list(page: number, limit: number, filters?: ReportListFilters): Observable<ReportListResponse> {
		const params = buildHttpParams({
			page,
			limit,
			from: filters?.from ? toLocalIsoDate(filters.from) : null,
			to: filters?.to ? toLocalIsoDate(filters.to) : null,
			reportId: filters?.reportId ?? null,
			boxId: filters?.boxId ?? null,
			driverId: filters?.driverId ?? null,
			driverUuid: filters?.driverUuid ?? null,
			scanId: filters?.scanId ?? null,
			sortBy: filters?.sortBy ?? null,
			sortDirection: filters?.sortDirection ?? null,
			answerFilter: filters?.answerFilter ?? null,
			paymentMethod: filters?.paymentMethod ?? null,
		});
		return this.http.get<ReportListResponse>(this.baseUrl, { params });
	}

	paymentMethods(): Observable<string[]> {
		return this.http
			.get<PaymentMethodsResponse>(`${this.baseUrl}/payment-methods`)
			.pipe(map((res) => res.data ?? []));
	}
}
